//cardInfoPopup
(function() {
    var MENU_STATE_SESSION_KEY = 'eventMembershipFilter';   // 필터 활성화 상태 저장할 세션 키
    
    var benefitItemList = '<li class="lists {{#if eventEndFlag == "Y"}}sold-out{{/if}}">'+
    '<div class="list-inner">' +
        '<div>'+
        '{{#if eventEndFlag != "Y"}}' +
        '<a href="{{eventUrl}}" target="{{#if eventTarget == "self"}}_self{{#else}}_blank{{/if}}" {{#if eventTarget != "self"}}title="새창 열림"{{/if}} data-ec-promotion="{{ecPromotion}}">' +
        '{{/if}}' +
            '<span class="thumb">' +
                '{{#if eventEndFlag != "N"}}<span class="dmm">'+
                    '<span class="blind">이벤트 종료</span>'+
                    '<span class="txt">종료</span>'+
                '</span>{{/if}}' +
                '<img src="{{eventListThumbnailPath}}" data-src="{{eventListThumbnailPath}}" alt="{{eventListThumbnailAltText}}" aria-hidden="true" onerror="this.src=\'/lg5-common/images/icons/noimage.svg\';">' +
            '</span>' +
            '<div class="info">' +
                '{{#if eventType}}' +
                '<div class="badge-container">' +
                    '<ul class="badge-list">' +
                    '{{#each eventTypeItem in eventType.split(",")}}' +
                        '<li class="badge-item">{{eventTypeItem}}</li>' +
                    '{{/each}}' +
                    '</ul>' +
                '</div>' +
                '{{/if}}' +
                '<div class="tit">'+
                    '<span class="blind">이벤트 제목</span>{{eventTitle}}'+
                '</div>'+
                '<p class="date"><span class="blind">이벤트 기간</span>{{eventFromDate}}~{{eventToDate}}</p>' +
                '{{#if winAnnouncementFlag == "Y"}}'+
                '<button id="eventWin" data-event-id="{{eventId}}" title="새창 열림" type="button" class="btn-link" >당첨자 발표</button>' +
                '{{/if}}' +
            '</div>' +
            '{{#if eventEndFlag != "Y"}}' +
            '</a>' +
            '{{/if}}' +
        '</div>'+   // tabindex
    '</div>'+  // .list-inner
'</li>';
	var isProgrammaticChange = false;
	var prevStatus = 'progress';

    var eventMembership = {
        el:{
            $section: null,
            $heroSwiper: null,
            $choiseFilterSwiper: null,
        },

        init: function() {
            var self = this;
            self.setting();
            self.bindEvents();
            vcui.require(['ui/carousel', 'libs/swiper-bundle-12.2.0.min'], function () {
                self.initHeroSwiper();
                self.initChoiseFilter();
                self.restoreFilterState();
                // CSR-8229 [수정요청] 복지몰 혜택/이벤트 페이지 개선요청 : 페이지 진입(GNB/URL) 시 filterTab focus 스크롤 방지
                self.quickFilterInitBtn({ skipFocus: true });
            });
        },

        setting: function() {
            var self = this;

            self.el.$section = $('.event-membership');
            self.el.$heroSwiper = self.el.$section.find('.new-hero-banner')
            self.el.$choiseFilterSwiper = self.el.$section.find('.choice-filter-wrap')
        },

        handler: {
            resize: function() {

            }
        },

        bindEvents: function() {
            var self = this;
            //BTOCSITE-77414 [웹앱 접근성 개선활동] 전시_이벤트/멤버십 > 1뎁스 탭에 따라 탭컨텐츠 타이틀 변경
			var $tabDepth1 = $('.evt-main-tab-wrap .tabs-wrap-new.flexible-tab.ui_stickyTab');
            var $tabflexbel = $('.evt-main-tab-wrap .tabs-wrap-new.flexibel-tab.ui_stickyTab');
			$(window).on('eventStickyTabchange',function(){
				var $tabContent = $('.evt-main-tab-wrap').next();
				if( $tabContent.hasClass('tab-contents')){
					$('.blind.content_title').remove();
					var contentTitle = $tabDepth1.find('li.on>a').text().replace('선택됨','');
					contentTitle = '<span class="blind content_title">'+contentTitle+' 카테고리 내용 시작</span>';
					$tabContent.prepend(contentTitle);
				}
			}).on('load',function(){
				$(window).trigger('eventStickyTabchange');
			});
			// CSR-15473 탭 선택 시 중앙정렬 적용 (flexible-tab, flexibel-tab(오타 클래스) 마크업 둘 다 동일하게 처리)
			// smoothScroll.js 기본값 scrollToActiveOffsetX(-200)은 다른 화면의 좌우 스크롤 보정용이라
			// 이 1뎁스 탭의 중앙정렬과는 맞지 않음 -> 공용 파일은 그대로 두고 이 인스턴스에서만 0으로 상쇄
			// (stickyTabchange 시점에는 setTabAcco()의 vcSmoothScroll 초기화가 이미 끝난 상태라 인스턴스가 항상 존재함)
			function centerActiveStickyTab(e, _obj) {
				var $tabWrap = $(this);
				$(window).trigger('eventStickyTabchange');

				var smoothScroll1Depth = $tabWrap.vcSmoothScroll('instance', false);
				if (smoothScroll1Depth) {
					smoothScroll1Depth.options.scrollToActiveOffsetX = 0;
				}
				$tabWrap.vcSmoothScroll('scrollToActive', 300);
			}
			$tabDepth1.add($tabflexbel).on('stickyTabchange', centerActiveStickyTab);

            $(document).on('click', '.evt-main-tab-wrap .choice-filter-wrap .swiper-slide button', function() {
                var $this = $(this);
                var hasOn = $this.hasClass('on');

                if (!hasOn) {
                    $this.addClass('on');
                    $this.attr('title','클릭 시 선택 해제됨');
                } else {
                    $this.attr('title','클릭 시 선택됨');
                    $this.removeClass('on');
                }

                self.quickFilterInitBtn();

                if ($this.closest('.choice-filter-wrap')[0].swiper) {
                    $this.closest('.choice-filter-wrap')[0].swiper.slideTo($this.closest('li').index() || 0, 0);
                }
            });

            $(document).on('click', '.evt-afilter-inner .item-reset button', function(e) {
                var $target = $(this);
                var $filterBtn = $target.closest('.evt-afilter-inner').find('li.swiper-slide button');

                $filterBtn.removeClass('on');
                $filterBtn.find('.blind').remove();
                $filterBtn.find('.close').remove();

                $('.list-sorting .chk-list input').each(function() {
                    var $this = $(this);
                    $this.prop('checked', false);
                });

                self.quickFilterInitBtn();
            });

            $(document).on('click', '.list-sorting .chk-list input', function() {
                self.quickFilterInitBtn();
            });

            $(window).on('plpFilter.swiper.init', function() {
                self.initChoiseFilter();
            });

            $(window).off('resize.evtM').on('resize.evtM', function() {
                self.handler.resize();
            });

            $('.tabs-wrap-new').on('stickyTabchange', function() {
                self.setFilterStorage();
            });

            $(document).on('click', '#categoryTab li', function() {
                self.requestData();
            });

            $(document).on('click', '#filterTab li', function() {
                self.requestData();
            });

            $(document).on('click', '.item-reset', function() {
                self.requestData();
            });

            $(document).on('click', '#eventGubun input', function() {
                if(this.name == 'chk01') {
                    isProgrammaticChange = true;
                    if ($('#chk01').is(':checked')) {
                        prevStatus = $('#eventStatus').vcSelectbox('value');
                        $('#eventStatus').vcSelectbox('value', 'all');
                    } else if (!$('#chk01').is(':checked')) {
                        $('#eventStatus').vcSelectbox('value', prevStatus);
                    }
                    isProgrammaticChange = false;
                }
                self.requestData();
            });

            $(document).on('change', '#eventStatus' ,function() {
				if (isProgrammaticChange) {
			        return; // 프로그램적 변경일 경우 무시
		        }
                self.requestData();
            });

            $(document).on('change', '#eventSort' ,function() {
				if (isProgrammaticChange) {
			        return; // 프로그램적 변경일 경우 무시
		        }
                self.requestData();
            });

			$(document).on('click', '#eventWin' ,function(e) {
				e.preventDefault();
                var eventId = $(this).data('event-id');

				requestModal(eventId);
            });

            function requestModal(eventId){
				var ajaxUrl = "/benefits/event/eventWin-"+eventId;
				window.open(ajaxUrl,'','width=912,height=760,scrollbars=yes');
			}
        },

        initHeroSwiper: function() {
            var self = this;
            self.el.$heroSwiper.each(function() {
                var $this = $(this);

                $this.vcCarousel({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    infinite: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    touchThreshold: 100,
                    cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                    speed: 300,
                }).on("carouselafterchange", function (e, slide, prev, next) {
                    setHeroBanner();
                })
            });

    
            function setHeroBanner(isFirst) {
                var heroList = self.el.$heroSwiper.find(".slide-track > li");
                var heroListCurrent = self.el.$heroSwiper.find(".slide-track > li.ui_carousel_current");
                var heroListAct = heroList.siblings(".ui_carousel_current").index();
                var heroListLength = heroList.length;
                var custom = self.el.$heroSwiper.find(".custom-indi-wrap");
                var slideCurrent = custom.find(".slide-page .current");
                var slideCount = custom.find(".slide-page .count");

                if (heroListLength > 1) {
                    custom.show();
                    custom.css("display", "flex");
                    slideCurrent.html('<span class="blind">현재 페이지</span>' + heroListAct);
                    slideCount.html('<span class="blind">총 페이지 수</span>' + (heroListLength - 2));
                } else {
                    custom.hide();
                }
            }
            setHeroBanner();
        },

        initChoiseFilter: function() {
            var self = this;

            self.el.$choiseFilterSwiper.each(function() {
                var $this = $(this);

                if(!$this.find('.swiper-slide').length) return;

                $this.addClass('swiper-ally-custom');

                if ($this.hasClass('swiper-initialized')) {
                    this.swiper.update();
                } else {
                    new Swiper(this, {
                        freeMode: true,
                        slidesPerView: 'auto',
                        resistance: true,
                        resistanceRatio: 0,
                        observer: true,
                        observeParents: true,
                        spaceBetween: 4,
                        breakpoints: {
                            767: {
                              spaceBetween: 8,
                            },
                          },
                        // slideToClickedSlide: true,
                        a11y: false
                    });
                }
            });
        },

        quickFilterInitBtn: function(options) {
            var self = this;
            options = options || {};
            var $resetBtn = $('.evt-afilter-inner .item-reset');

            if (($('.evt-main-tab-wrap .choice-filter-wrap .swiper-slide button.on').length + $('.list-sorting .chk-wrap input:checked').length) > 0) {
                $resetBtn.show();
            } else {
                $resetBtn.hide();
                // CSR-4849 WA: 필터/체크 해제 시 포커스 이동(해당 섹션으로 스크롤)
                // CSR-8229: 페이지 진입(init) 시에만 skipFocus로 focus·스크롤 방지
                if (!options.skipFocus) {
                    $('#filterTab li:first button').focus();
                }
            }

            $('.evt-main-tab-wrap .choice-filter-wrap').each(function() {
                if (this.swiper) {
                    this.swiper.update();
                }
            });

            self.setFilterStorage();
        },

        setFilterStorage: function() {
            var self = this;
            var tabIndex = self.el.$section.find('.tabs-wrap-new .on').index();
            var act1 = $.map(self.el.$section.find('.evt-main-tab-wrap .choice-filter-wrap .swiper-slide button.on'), function(el){return $(el).closest('li').index()});
            var act2 = $.map(self.el.$section.find('.list-sorting .chk-list input:checked'), function(el){return $(el).closest('.chk-wrap').index()});
			var eventStatus = $('#eventStatus').vcSelectbox('value');
            var eventSort = $('#eventSort').vcSelectbox('value');

            sessionStorage.setItem(MENU_STATE_SESSION_KEY, JSON.stringify({
                tabIndex: tabIndex,
                act1: act1,
                act2: act2,
				eventStatus: eventStatus, // Save eventStatus
                eventSort: eventSort // Save eventSort
            }));
        },

        restoreFilterState: function() {
            var self = this;
            var stateData = sessionStorage.getItem(MENU_STATE_SESSION_KEY) ? JSON.parse(sessionStorage.getItem(MENU_STATE_SESSION_KEY)) : null;
            var navi = performance.getEntriesByType("navigation")[0];

            if (navi && navi.type === 'back_forward' && stateData) {
                var tabIndex = stateData.tabIndex;
                var act1 = stateData.act1;
                var act2 = stateData.act2;
                var eventStatus = stateData.eventStatus;
                var eventSort = stateData.eventSort;

                self.el.$section.find('.tabs-wrap-new').each(function() {
                    var $this = $(this);
                    if ($this.vcStickyTab) {
                        $this.vcStickyTab('select', tabIndex, true);
                    }
                    if ($this.vcSmoothScroll) {
                        $this.vcSmoothScroll('scrollToActive', 0);
                    }
                });

                act1.forEach(function(val) {
                    var $target = self.el.$choiseFilterSwiper.find('.swiper-slide:eq('+ val +') button');
                    if (!$target.hasClass('on')) {
                        $target.addClass('on');
                    }
                });

                act2.forEach(function(val) {
                    var $target = self.el.$section.find('.list-sorting .chk-list:eq('+ val +') input');
                    if (!$target.is(':checked')) {
                        $target.prop('checked', true);
                    }
                });

				// Set the eventStatus and eventSort values
				isProgrammaticChange=true;
                if ($('#eventStatus').length) $('#eventStatus').vcSelectbox('value', eventStatus);
                if ($('#eventSort').length) $('#eventSort').vcSelectbox('value', eventSort);
				isProgrammaticChange=false;

				self.quickFilterInitBtn(); // Update the filter button state
				self.requestData();
            } else {
                sessionStorage.removeItem(MENU_STATE_SESSION_KEY);
            }
        },

        requestData: function() {
            var ajaxUrl ='/ajax/v1/event/retrieveBenefitList';
            var categoryId = getActiveCategoryId();
            var eventType = getActiveEventType();
            var winFlag = getWinFlag();
            var subFlag = getSubFlag();
            var eventStatus = getActiveStatus();
            var eventSort = getActiveSortId();
            var data = {
                categoryId : categoryId,
                eventType : eventType.toString(),
                winFlag : winFlag,
                subFlag : subFlag,
                eventStatus : eventStatus,
                eventSort : eventSort
            }
            
            var self = this;
            lgkorUI.requestKongAjax("exhibitionsvc", ajaxUrl, {
                method: "POST",
                data: data,
                success: function(result) {
                    self.updateList(result.data);
					self.setFilterStorage();
                    console.log(result)
                },
                error: function(jqXHR) {
                    console.log(jqXHR)
                }
            });

            function getActiveCategoryId(){
                var categoryId ='';
                $('#categoryTab li').each(function() {
                    if ($(this).hasClass('on')) {
                        categoryId = $(this).data('category-id');
                    }
                })
                return categoryId;
            }

            function getActiveEventType() {
                var activeEventType = [];
                $('#filterTab li').each(function() {
                    var filterId = $(this).data('filter-id');
                    var button = $(this).find('button');

                    if (button.hasClass('on')) {
                        activeEventType.push(filterId);
                    }
                });
                return activeEventType;
            }

            function getWinFlag(){
                return $('#chk01').is(':checked') ? 'Y' : 'N';
            }

            function getSubFlag(){
                return $('#chk02').is(':checked') ? 'Y' : 'N';
            }

            function getActiveStatus(){
                return $('#eventStatus').vcSelectbox('value');
            }

            function getActiveSortId(){
                return $('#eventSort').vcSelectbox('value');
            }

        },

        updateList: function(data) { // Moved updateList here
            var $list = $('ul#benefitList');
            var $noData = $('div.no-data');

            var benefitList = data.benefitList;

            $("#totalBenefitCount").text(benefitList.length);

            $list.empty();
            if (benefitList.length > 0) {
                $noData.hide();
                $.each(benefitList, function(index, item) {
                    item.eventType = item.eventType ? item.eventType : "";
                    item.eventId = item.eventId ? item.eventId : null;

                    var ecPromotion = {
                        "promo_id": item.eventUrl,
                        "promo_name": item.eventTitle,
                        "promo_creative": item.eventListThumbnailPath
                    };
                    item.ecPromotion = JSON.stringify(ecPromotion);

                    $list.append(vcui.template(benefitItemList, item));
                });
            } else {
                $noData.show();
            }
        },
    }

    $(window).ready(function() {
        eventMembership.init();
    });

})();
